// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckboxTerms_checkbox__WGrvd"};